import React from 'react';
import {translate} from 'react-i18next';
import {Modal} from "antd";
import Call from "../../../hocs/call";
import {onUpdateDatabrowserCache} from "./actions";
import {connect} from "react-redux";
import {compose} from "redux";

const mapDispatchToProps = dispatch => ({
  callback: () => dispatch(onUpdateDatabrowserCache())
});

const UpdateDatabrowserCache = ({t, callback}) =>
  <Call
    cb={() => Modal.confirm({
      title: t('scenes.dataManager.updateDataBrowserCache.modal.title'),
      content: t('scenes.dataManager.updateDataBrowserCache.modal.content'),
      onOk() {
        callback();
      },
      cancelText: t('commons.buttons.cancel.title')
    })}
  >
    <span></span>
  </Call>;

export default compose(
  translate(),
  connect(null, mapDispatchToProps)
)(UpdateDatabrowserCache);
